var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isHidden === false)?_c('div',{staticClass:"chawgt",class:{ 'chawgt-left-pos': _vm.isLeftPos },style:(_vm.style)},[_c('chatbox'),_c('div',{staticClass:"chawgt-button"},[_c('CTA'),_c('main-button')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }